/*
This file is for handle Bar.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 29/11/2017 07:14 PM
*/

/* global document, clearTimeout, setTimeout */
import ViewProperties from './ViewProperties';
import View from './View';
import Element from './Element';
import Speaker from './component/Speaker';
import Zoomer from './component/Zoomer';
import Branding from './component/Branding';
import Recorder from './component/Recorder';
import Share from './component/Share';
import Play from './component/Play';
import Mic from './component/microphone';
import DefaultSkin from './assets/css/defaultCss';

/*
 * Bar represents the bottom menu bar of every mediaPlayer.
 * It contains a Speaker and an icon.
 * Every Bar is a View.
 * Ex.: var bar = Bar({elementID: element, id: id});
 */
const Bar = (spec) => {
    const that = View({});
    // Variables
    let waiting;
    let toolbar;
    toolbar = ViewProperties().toolbar.default;
    let isDefault = false;
    //options attribute checking
    if (spec.options !== undefined && spec.options.player !== undefined) {
        that.playerProperties = spec.options.player;
    }
    if (spec.options.toolbar) {
        const barUser = spec.options.toolbar;
        if (Element.checkParam(barUser.position)) { toolbar.position = barUser.position; }
        if (Element.checkParam(barUser.class)) { toolbar.class = barUser.class; }
        if (Element.checkParam(barUser.skin)) {
            toolbar.skin = barUser.skin;
            isDefault = toolbar.skin === 'default';
        }
        if (Element.checkParam(barUser.displayMode)) { toolbar.displayMode = barUser.displayMode; } else { toolbar.displayMode = barUser.displayMode; }
        if (Element.checkParam(barUser.autoDisplayTimeout)) { toolbar.autoDisplayTimeout = barUser.autoDisplayTimeout; }
        if (barUser.buttons) {
            toolbar.buttons = barUser.buttons;
        }
    }


    // DOM element in which the Bar will be appended
    that.elementID = spec.elementID;

    // Bar ID
    that.id = spec.id;

    // Container
    if (isDefault) {
        that.div = Element({
            name: 'div', id: `bar_${that.id}`, class: 'vcx_bar', style: DefaultSkin.vcx_bar,
        });
    } else {
        that.div = Element({ name: 'div', id: `bar_${that.id}`, class: `vcx_bar ${toolbar.skin}_vcx_bar` });
    }

    Element.getById(that.elementID).appendChild(that.div);

    //bar
    if (isDefault) {
        that.bar = Element({
            name: 'div',
            id: `subbar_${that.id}`,
            class: `vcx_subbar ${toolbar.class}`,
            style: DefaultSkin[`vcx_subbar_${toolbar.position}`],
        });
    } else {
        that.bar = Element({
            name: 'div',
            id: `subbar_${that.id}`,
            class: `vcx_subbar ${toolbar.skin}_vcx_subbar_${toolbar.position} ${toolbar.class}`,
        });
    }
    that.div.appendChild(that.bar);
    dragElement(that.bar);

    function dragElement(elmnt) {
        let pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0;
        if (document.getElementById(elmnt.id)) {
            /* if present, the header is where you move the DIV from:*/
            document.getElementById(elmnt.id).onmousedown = dragMouseDown;
        } else {
            /* otherwise, move the DIV from anywhere inside the DIV:*/
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = `${elmnt.offsetTop - pos2}px`;
            elmnt.style.left = `${elmnt.offsetLeft - pos1}px`;
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    //Play icon
    if (toolbar.buttons.play) {
        that.playIcon = Play({ stream: spec.stream, skin: toolbar.skin });
        that.bar.appendChild(that.playIcon);
    }

    // Zoom icon
    if (toolbar.buttons.zoom) {
        that.zoomIcon = Zoomer({ skin: toolbar.skin, player: that.playerProperties });
        that.bar.appendChild(that.zoomIcon);
    }

    // Record icon
    if (toolbar.buttons.record) {
        that.recIcon = Recorder({ skin: toolbar.skin, stream: spec.stream });
        that.bar.appendChild(that.recIcon);
    }

    // Share icon
    if (toolbar.buttons.share) {
        that.shareIcon = Share({ skin: toolbar.skin, stream: spec.stream });
        that.bar.appendChild(that.shareIcon);
    }

    // Mic icon
    if (toolbar.buttons.mic) {
        that.micIcon = Mic({ skin: toolbar.skin, stream: spec.stream });
        that.bar.appendChild(that.micIcon);
    }

    // Brand icon
    let brandTemp = {};
    if (spec.options && spec.options.toolbar && spec.options.toolbar.branding) {
        brandTemp = spec.options.toolbar.branding;
    }
    brandTemp.skin = toolbar.skin;
    that.brand = Branding(brandTemp);
    that.bar.appendChild(that.brand);

    // Speaker component
    if (toolbar.buttons.volume && !spec.stream.screen && (spec.options === undefined ||
        spec.options.speaker === undefined ||
        spec.options.speaker === true)) {
        that.speaker = Speaker({
            elementID: `subbar_${that.id}`,
            id: that.id,
            stream: spec.stream,
            media: spec.media,
            position: toolbar.position,
            skin: toolbar.skin,
        });
    }

    // Toolbar display mode set
    if (toolbar.displayMode) {
        if (toolbar.displayMode == 'auto') {
            that.div.onmouseover = function (event) {
                const elem = event.currentTarget;
                setTimeout(
                    () => {
                        Element.getByClass('vcx_subbar', elem).style.display = 'block';
                    },
                    (parseInt(toolbar.autoDisplayTimeout) * 1000),
                );
            };
            that.div.onmouseout = function (event) {
                const elem = event.currentTarget;
                setTimeout(
                    () => {
                        Element.getByClass('vcx_subbar', elem).style.display = 'none';
                    },
                    (parseInt(toolbar.autoDisplayTimeout) * 1000),
                );
            };
            Element.getByClass('vcx_subbar', that.div).style.display = 'none';
        } else { Element.getByClass('vcx_subbar', that.div).style.display = 'block'; }
    } else {
        Element.getByClass('vcx_subbar', that.div).style.display = 'none';
    }
    return that;
};


export default Bar;



//////////////////
// WEBPACK FOOTER
// ./src/views/Bar.js
// module id = 180
// module chunks = 0